// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\Service.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { post } from '../../../../../../libs/com/MetaPattern/Product/IDE/Util/Request';
class PublishAPPDTO {
  oldAPP: string;
  newAPP: string;
  dBType: number;
  connectionString: string;

  public toJson(): any {
    const json: any = {};
    json.OldAPP = this.oldAPP;
    json.NewAPP = this.newAPP;
    json.DBType = this.dBType;
    json.ConnectionString = this.connectionString;
    return json;
  }
}
class CreateDDLScriptDTO {
  aPP: string;
  dBType: number;
  connectionString: string;

  public toJson(): any {
    const json: any = {};
    json.APP = this.aPP;
    json.DBType = this.dBType;
    json.ConnectionString = this.connectionString;
    return json;
  }
}
class PublishScriptsDTO {
  sqlScripts: Array<string>;
  dBType: number;
  connectionString: string;

  public toJson(): any {
    const json: any = {};
    json.SqlScripts = [];
    this.sqlScripts.forEach((item) => {
      json.SqlScripts.push(item);
    });
    json.DBType = this.dBType;
    json.ConnectionString = this.connectionString;
    return json;
  }
}
/**
 * 持久层服务 服务类
 * 持久层操作服务
 */
export class PersistenceService {
  static async PublishAPPAsync(oldAPP: string, newAPP: string, dBType: number, connectionString: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new PublishAPPDTO();
      dto.oldAPP = oldAPP;
      dto.newAPP = newAPP;
      dto.dBType = dBType;
      dto.connectionString = connectionString;
      post('metapattern-ide-mpapp/service/persistenceservice/publishapp', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async CreateDDLScriptAsync(aPP: string, dBType: number, connectionString: string): Promise<string | null> {
    return new Promise((resolve, reject) => {
      const dto = new CreateDDLScriptDTO();
      dto.aPP = aPP;
      dto.dBType = dBType;
      dto.connectionString = connectionString;
      post('metapattern-ide-mpapp/service/persistenceservice/createddlscript', dto.toJson())
        .then((response: any) => {
          let result: string | null = null;
          if (response) {
            result = response as string;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }

  static async PublishScriptsAsync(sqlScripts: Array<string>, dBType: number, connectionString: string): Promise<boolean | null> {
    return new Promise((resolve, reject) => {
      const dto = new PublishScriptsDTO();
      dto.sqlScripts = sqlScripts;
      dto.dBType = dBType;
      dto.connectionString = connectionString;
      post('metapattern-ide-mpapp/service/persistenceservice/publishscripts', dto.toJson())
        .then((response: any) => {
          let result: boolean | null = null;
          if (response) {
            result = response as boolean;
          }
          resolve(result);
        })
        .catch(error => {
          // TODO : 格式化错误返回
          reject(error);
        });
    });
  }
}
